import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import loadAccountsIfNeeded from "@insite/client-framework/Store/Pages/RfqRequestQuote/Handlers/LoadAccountsIfNeeded";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import Page from "@insite/mobius/Page";
import React, { Component } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    loadAccountsIfNeeded,
    loadCurrentCart,
};

const mapStateToProps = (state: ApplicationState) => {
    // Verndale Customization
    const cartState = getCurrentCartState(state);
    // END Verndale Customization

    return {
        cart: getCurrentCartState(state),
        isUpdatingCartLine: state.pages.cart.isUpdatingCartLine,
        // Verndale Customization
        shouldLoadCart:
            !cartState.isLoading &&
            (!cartState.value || (cartState.value.lineCount && !cartState.value.cartLines?.length)),
        // END Verndale Customization
    };
};

type Props = ResolveThunks<typeof mapDispatchToProps> & PageProps & ReturnType<typeof mapStateToProps>;

export interface RfqRequestQuotePageStyles {
    loadingOverlay?: LoadingOverlayProps;
}

export const rfqRequestQuotePageStyles: RfqRequestQuotePageStyles = {
    loadingOverlay: {
        css: css`
            width: 100%;
        `,
    },
};

const RfqRequestQuoteGuestPage = ({
    id,
    cart,
    isUpdatingCartLine,
    shouldLoadCart,
    loadAccountsIfNeeded,
    loadCurrentCart,
}: Props) => {
    const styles = rfqRequestQuotePageStyles;
    React.useEffect(() => {
        loadAccountsIfNeeded();

    }, []);

    return (
        <Page>
            <LoadingOverlay {...styles.loadingOverlay} loading={cart.isLoading || isUpdatingCartLine}>
                <Zone contentId={id} zoneName="Content" />
            </LoadingOverlay>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RfqRequestQuoteGuestPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [],
        pageType: "Content",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "RfqRequestQuoteGuestPage" instead of this constant.
 */
export const RfqRequestQuotePageContext = "RfqRequestQuoteGuestPage";
